import React from 'react';
import { Box } from 'rebass/styled-components';

import MainLayout from '../../components/layout/Main';
import useIframeMessage from '../../hooks/useIframeMessage';
import usePageTitle from '../../hooks/usePageTitle';

export const CRM = () => {
  usePageTitle('CRM');
  const iframeUrl = useIframeMessage('https://app-next.findem-staging.com', '/crm');

  return (
    <MainLayout
      containerProps={{
        pb: 0,
        minHeight: '100vh',
      }}
    >
      <Box
        as="iframe"
        src={iframeUrl}
        allow="clipboard-read; clipboard-write"
        sx={{
          width: '100%',
          height: 'calc(100vh - 64px)',
          border: 'none',
          flex: 1,
        }}
      />
    </MainLayout>
  );
};
